import React, { memo, useEffect, useRef } from "react"
import PropTypes from "prop-types"

const CText = ({
  lang,
  richText,
  noArrows,
  maxDesktopText,
  maxMobileText,
  radioButtonIdOffset,
  viewport,
}) => {
  const textRef = useRef(null)

  useEffect(() => {
    textRef.current.richText = richText
    textRef.current.noArrows = noArrows
    if (radioButtonIdOffset) {
      textRef.current.radioButtonIdOffset = radioButtonIdOffset
    }
  }, [])

  useEffect(() => {
    textRef.current.noArrows = noArrows
  }, [noArrows])

  return (
    <c-text
      slider-lang={lang}
      max-desktop-text={maxDesktopText}
      max-mobile-text={maxMobileText}
      viewport={viewport}
      ref={textRef}
    />
  )
}

CText.propTypes = {
  lang: PropTypes.string,
  richText: PropTypes.array,
  noArrows: PropTypes.bool,
  maxDesktopText: PropTypes.number,
  maxMobileText: PropTypes.number,
  radioButtonIdOffset: PropTypes.number,
  viewport: PropTypes.string,
}

export default memo(CText)
